export interface IAddress {
    addressCode: string;
    isDefault: boolean;
    address1: string;
    address2: string;
    city: string;
    state: string;
    country: string;
    zip: string;
}
export interface IAddressEmitter {
  addressCode: string;
  addressType: string;
}
